import { createApiAction } from '@app/packages/api/utils'
import type { ApiConsentType, ApiPolicy } from '@app/packages/api/v2/types/entities'
import type { GetApiPolicyQuery } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getPolicies = (query: GetApiPolicyQuery = {}) =>
  createApiAction('getPolicies', dispatch =>
    dispatch<{ data: ApiPolicy[]; included?: ApiConsentType[] }>({ method: 'GET', endpoint: v2Path('/api/v2/policies', query) })
  )
